import { createContext } from "react"
import { ScreenSizeProps } from "./model"

export const SizeContext = createContext<ScreenSizeProps["screenSize"]>("m")
